import classNames from "classnames";
import * as ToastPrimitive from "@radix-ui/react-toast";
import IconButton from "../IconButton/IconButton";
import { Alert, CheckCircle, Close } from "../Icon/Icon";
import styles from "./Toast.module.scss";

export type ToastProps = {
  title: string;
  description?: React.ReactNode;
  onOpenChange?: (open: boolean) => void;
  variant?: "success" | "error";
};

function Toast({
  title,
  description,
  onOpenChange,
  variant = "success",
}: ToastProps) {
  return (
    <ToastPrimitive.Root
      className={classNames(styles.root, styles[variant])}
      onOpenChange={onOpenChange}
    >
      {variant === "success" && (
        <CheckCircle size="medium" className={styles.icon} />
      )}
      {variant === "error" && <Alert size="medium" className={styles.icon} />}
      <div className={styles.body}>
        <ToastPrimitive.Title className={styles.title}>
          {title}
        </ToastPrimitive.Title>
        {description && (
          <ToastPrimitive.Description className={styles.description}>
            {description}
          </ToastPrimitive.Description>
        )}
      </div>
      <ToastPrimitive.Close asChild className={styles.close}>
        <IconButton aria-label="Close" IconComponent={Close} />
      </ToastPrimitive.Close>
    </ToastPrimitive.Root>
  );
}

export default Toast;
